var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScriptsSettings = function SvgScriptsSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "scripts-settings_svg__a",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(196, 196, 196)",
    d: "M0 0h60v60H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#scripts-settings_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 30,
    x: 36,
    y: 6,
    fill: "#fff",
    stroke: "rgb(49, 143, 255)",
    strokeWidth: 2,
    rx: 1,
    transform: "rotate(90 36 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 30,
    x: 36,
    y: 12,
    fill: "#fff",
    stroke: "rgb(49, 143, 255)",
    strokeWidth: 2,
    rx: 1,
    transform: "rotate(90 36 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    x: 0.5,
    y: -0.5,
    fill: "#fff",
    stroke: "rgb(0, 234, 248)",
    rx: 0.5,
    transform: "matrix(1 0 0 -1 10 27)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    x: 0.5,
    y: -0.5,
    fill: "#fff",
    stroke: "rgb(0, 234, 248)",
    rx: 0.5,
    transform: "matrix(1 0 0 -1 26 27)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    x: -0.5,
    y: -0.5,
    fill: "#fff",
    stroke: "rgb(0, 234, 248)",
    rx: 0.5,
    transform: "matrix(0 -1 -1 0 21 39)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    x: -0.5,
    y: -0.5,
    fill: "#fff",
    stroke: "rgb(0, 234, 248)",
    rx: 0.5,
    transform: "matrix(0 -1 -1 0 21 22)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    y: -0.71,
    fill: "#fff",
    stroke: "rgb(0, 234, 248)",
    rx: 0.5,
    transform: "scale(1 -1) rotate(45 48.9 -1.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    y: -0.71,
    fill: "#fff",
    stroke: "rgb(0, 234, 248)",
    rx: 0.5,
    transform: "scale(1 -1) rotate(45 40.41 18.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    x: -0.71,
    fill: "#fff",
    stroke: "rgb(0, 234, 248)",
    rx: 0.5,
    transform: "scale(-1 1) rotate(-45 24.98 55.82)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    x: -0.71,
    fill: "#fff",
    stroke: "rgb(0, 234, 248)",
    rx: 0.5,
    transform: "scale(-1 1) rotate(-45 18.52 31.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 13,
    x: 21.23,
    y: 43.92,
    fill: "#fff",
    stroke: "rgb(49, 143, 255)",
    strokeWidth: 2,
    rx: 3,
    transform: "rotate(-28.96 21.23 43.92)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.83 29.24a3 3 0 0 1 5.25-2.9l4.35 7.87a3 3 0 1 1 5.25-2.9l.97 1.75a3 3 0 1 1 5.25-2.9l.73 1.32.35-.05a3 3 0 0 1 5.63-1.56L49.99 36l1.46 2.62 1.93 3.5a9 9 0 0 1-3.51 12.24l-5.25 2.9a9 9 0 0 1-12.24-3.52L29 47.62 18.83 29.24Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49, 143, 255)",
    d: "m18.83 29.24.87-.48-.87.48Zm8.73 5.46a1 1 0 1 0 1.75-.97l-1.75.97Zm6.22-1.16a1 1 0 1 0 1.75-.96l-1.75.96Zm6.12-3.39-.87.49.87-.49Zm.73 1.33-.87.48a1 1 0 0 0 1.04.5l-.17-.98Zm.35-.05.13.99a1 1 0 0 0 .87-1.03l-1 .04Zm5.63-1.56.87-.48-.87.48ZM49.99 36l-.87.48.87-.48Zm1.46 2.62-.88.49.88-.49Zm1.93 3.5.88-.48-.88.48Zm-21 11.62.88-.48-.88.48ZM29 47.62l-.87.48.87-.48Zm-9.47-23.33a4 4 0 0 0-1.57 5.44l1.75-.97a2 2 0 0 1 .78-2.72l-.96-1.75Zm5.43 1.57a4 4 0 0 0-5.43-1.57l.96 1.75a2 2 0 0 1 2.72.78l1.75-.96Zm4.36 7.87-4.36-7.87-1.75.96 4.36 7.88 1.75-.97Zm-.19-4.47a4 4 0 0 0-1.56 5.44l1.75-.97a2 2 0 0 1 .78-2.72l-.97-1.75Zm5.44 1.57a4 4 0 0 0-5.44-1.57l.97 1.75a2 2 0 0 1 2.72.78l1.75-.96Zm.97 1.75-.97-1.75-1.75.96.97 1.75 1.75-.96Zm-.19-4.47a4 4 0 0 0-1.56 5.43l1.75-.96a2 2 0 0 1 .78-2.72l-.97-1.75Zm5.44 1.56a4 4 0 0 0-5.44-1.56l.97 1.75a2 2 0 0 1 2.72.78l1.75-.97ZM41.5 31l-.73-1.32-1.75.97.73 1.32L41.5 31Zm-.65-.56-.39.06.33 1.97.3-.04-.24-1.99Zm1.12.96A2 2 0 0 1 43 29.59l-.97-1.75a4 4 0 0 0-2.06 3.63l2-.07ZM43 29.59a2 2 0 0 1 2.72.78l1.75-.97a4 4 0 0 0-5.44-1.56l.97 1.75Zm2.72.78 3.39 6.12 1.75-.96-3.39-6.13-1.75.97Zm3.39 6.12 1.45 2.63 1.75-.97-1.45-2.62-1.75.96Zm5.14 5.16-1.94-3.5-1.75.97 1.94 3.5 1.75-.97Zm-3.91 13.6a10 10 0 0 0 3.9-13.6l-1.74.97a8 8 0 0 1-3.13 10.87l.97 1.75Zm-5.25 2.9 5.25-2.9-.97-1.76-5.25 2.9.97 1.76Zm-13.6-3.91a10 10 0 0 0 13.6 3.9l-.97-1.74a8 8 0 0 1-10.87-3.13l-1.75.97Zm-3.38-6.13 3.39 6.13 1.75-.97-3.39-6.13-1.75.97ZM17.95 29.73 28.12 48.1l1.75-.97L19.7 28.76l-1.75.97Z"
  }))));
};
export default SvgScriptsSettings;